import { setTextTracksToHidden } from "../useSubtitles/utils";

export const showFullscreenButton = ({
  forceShowFullScreenBtn,
  isCarousel,
  isMobileSize,
  isVertical,
  isOpenSticky
}) => {
  // If forceShowFullScreenBtn is explicitly true or false, return its value
  if (typeof forceShowFullScreenBtn === "boolean") {
    return forceShowFullScreenBtn;
  }

  // No fullscreen btn in the carousel vids
  if (isCarousel) return false;
  // Show fullscreen btn for horizontal vids
  if (!isVertical) return true;
  // For vertical vids, we want the fullscreen btn on mobile and in the sticky player
  return isMobileSize || isOpenSticky;
};

/**
 * Displays iOS captions on a video element.
 *
 * @param {boolean} showSubtitles - Flag indicating whether to show subtitles.
 * @param {HTMLVideoElement} videoElement - The video element to display captions on.
 * @returns {void}
 */
export const displayIOSCaptions = (showSubtitles, videoElement) => {
  setTextTracksToHidden(videoElement);
  if (showSubtitles) {
    videoElement.textTracks[0].mode = "showing";
  }
};

/**
 * Returns a boolean indicating whether subtitles are enabled on an iOS device and hides any showing subtitles.
 *
 * @param {HTMLVideoElement} videoElement - The video element to check for subtitles.
 * @returns {boolean} - True if subtitles are enabled, false otherwise.
 */
export const getSubtitlesDisplayFromIOSCaptions = videoElement => {
  let subsAreEnabled = false;
  for (const track of videoElement.textTracks) {
    if (track.mode === "showing") {
      subsAreEnabled = true;
    }
    track.mode = "hidden";
  }
  return subsAreEnabled;
};
